"use strict";

var authenticateFormDirective = angular.module('authenticateFormDirective', []);

authenticateFormDirective.directive('authenticateForm', function (){
   
    return{
        restrict: 'E',
        scope: {
            user: '=user',
            goBack: '&',
            continue: '&',
        },
        templateUrl: 'js/directives/templates/authenticateForm.tpl.html',
        link: function (scope, element, attrs) { 
                        
        },
        controller: ['$scope', 'userService', 'impersonationService','storeService' , function($scope, userService, impersonationService, storeService){
            $scope.error = false;
            $scope.password = '';

            $scope.hide = function(){
                return impersonationService.isUserImpersonated();
            }

            $scope.title = $scope.hide() === true? "label.directives.authenticateForm.impersonationNoPassword" : "label.directives.authenticateForm.EnterPassword";

            $scope.authenticateUser = function(){
            if(impersonationService.isUserImpersonated()){
                if ($scope.continue() != null) {
                    $scope.continue()();
                } else {
                    $scope.$parent.next();
                }
            }else {
                userService.authenticate($scope.user.username, $scope.password).then(function (resource) {
                        if ($scope.continue() != null) {
                            $scope.continue()();
                        } else {
                            $scope.$parent.next();
                        }
                    },
                    function (status) {
                        if (status.status === 404) $scope.error = true;
                    });
            }
        }
        }]
    };
 
});

